import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cancelInvitation } from "../actions/cancelInvitation";
import { useDispatch } from "react-redux";
import { fetchBenefits } from "../../../permissions/benefits/redux/benefits.thunks";
import { AppDispatch } from "../../../redux/store";

type CancelInvitationInput =
  | string
  | {
      invitationUid: string;
      companyId?: number;
    };

export const useCancelInvitation = () => {
  const qc = useQueryClient();
  const dispatch = useDispatch<AppDispatch>();

  return useMutation({
    mutationFn: (input: CancelInvitationInput) => {
      if (typeof input === "string") {
        return cancelInvitation(input);
      }

      return cancelInvitation(input.invitationUid, input.companyId);
    },
    retry: false,
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["invitations"] });
      await qc.invalidateQueries({ queryKey: ["received-invitations"] });
      dispatch(fetchBenefits());
    },
  });
};
